export default function MetaIcon() {
  return (
    <img
      src="https://app.vectorshift.ai/meta-logo.png"
      width="16px"
      height="16px"
      alt="Llama"
    />
  );
}
